
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 25.184l-2.608-5.564-6.288 1.325.41 2.067 3.424-.742c-1.533 2.808-4.447 4.61-7.617 4.61-4.857 0-8.794-4.08-8.794-9.115H6.483C6.483 23.965 11.339 29 17.32 29c3.988 0 7.618-2.279 9.51-5.83l1.38 2.862L30 25.184z","fill":"#66C552"}}),_c('path',{attrs:{"d":"M13.947 14.055l-.41-2.066-3.424.741c1.533-2.808 4.447-4.61 7.617-4.61 4.857 0 8.794 4.08 8.794 9.115h2.044C28.568 11.035 23.712 6 17.73 6c-3.988 0-7.618 2.279-9.51 5.83L6.84 8.968 5 9.922l2.659 5.458 6.288-1.325z","fill":"#244C73"}})])
          )
        }
      }
    